import { createContext, useContext, useState } from "react";

const UserTaskContext = createContext({
  list: [],
  setList: () => {},
  summary: { totalTasks: 0, deadlinePassed: 0, deadlineReached: 0 },
  setSummary: () => {},
  selectedUser: null,
  setSelectedUser: () => {},
  dateRange: {},
  setDateRange: () => {},
  reloadRequired: false,
  setReloadRequired: () => {},
});

export const UserTaskProvider = ({ children }) => {
  const [list, setList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });
  const [summary, setSummary] = useState({
    doneAfterDeadline: 0,
    acceptedAfterDeadline: 0,
    ackAfterDeadline: 0,
    pendingDone: 0,
    pendingAck: 0,
    pendingAcceptance: 0,
    totalTasks: 0,
  });

  const [reloadRequired, setReloadRequired] = useState(false);

  return (
    <UserTaskContext.Provider
      value={{
        list,
        setList,
        summary,
        setSummary,
        selectedUser,
        setSelectedUser,
        dateRange,
        setDateRange,
        reloadRequired,
        setReloadRequired,
      }}
    >
      <>{children}</>
    </UserTaskContext.Provider>
  );
};

export const useUserTaskContext = () => {
  const context = useContext(UserTaskContext);
  if (!context) {
    throw new Error(
      "useUserTaskContext must be used within a UserTaskProvider"
    );
  }
  return context;
};
